import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { EyeOff } from 'lucide-react'
import { COLLECTION_STOREFRONT_VISIBILITY_ISSUE } from './designForm.utils'

const collectionStorefrontVisibilityMessages = {
  [COLLECTION_STOREFRONT_VISIBILITY_ISSUE.HIDDEN]:
    'This collection is hidden. Make it visible before showing it on your storefront.',
  [COLLECTION_STOREFRONT_VISIBILITY_ISSUE.NO_AVAILABLE_PRODUCTS]:
    'This collection has no available products. Add one before showing it on your storefront.',
}

const getCollectionStorefrontVisibilityMessage = (visibilityIssue) =>
  collectionStorefrontVisibilityMessages[visibilityIssue] ??
  'This collection is hidden on your storefront.'

export default function CollectionStorefrontVisibilityIndicator({
  visibilityIssue,
  withTooltip = true,
  message: messageOverride,
}) {
  const message = messageOverride ?? getCollectionStorefrontVisibilityMessage(visibilityIssue)
  const icon = (
    <span className="inline-flex items-center text-status-warning-foreground" aria-label={message}>
      <EyeOff className="size-3" />
    </span>
  )

  if (!withTooltip) {
    return icon
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>{icon}</TooltipTrigger>
      <TooltipContent side="top" className="w-61" variant="warning">
        {message}
      </TooltipContent>
    </Tooltip>
  )
}

export { getCollectionStorefrontVisibilityMessage }
